// Coreografía de entrada del portal de acceso (login, recuperar y
// restablecer contraseña). El hairline rojo de la tarjeta se dibuja
// vía CSS (pseudo-elemento); aquí solo entran los elementos.
import { animate, stagger } from 'motion';

const EASE_OUT = [0.16, 1, 0.3, 1];

function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const copy = Array.from(document.querySelectorAll('.hero-eyebrow, .hero-title, .hero-subtitle'));
    const rows = Array.from(document.querySelectorAll('.kpi-teaser-row, .kpi-teaser-foot'));
    const card = document.querySelector('.access-actions');

    copy.concat(rows).forEach((el) => {
        el.style.opacity = '0';
    });
    if (card) {
        card.style.opacity = '0';
    }

    if (copy.length) {
        animate(copy, { opacity: [0, 1], y: [14, 0] }, {
            duration: 0.7,
            ease: EASE_OUT,
            delay: stagger(0.08, { startDelay: 0.05 }),
        });
    }

    if (rows.length) {
        animate(rows, { opacity: [0, 1], y: [10, 0] }, {
            duration: 0.6,
            ease: EASE_OUT,
            delay: stagger(0.06, { startDelay: 0.3 }),
        });
    }

    if (card) {
        animate(card, { opacity: [0, 1], y: [14, 0] }, {
            duration: 0.7,
            ease: EASE_OUT,
            delay: 0.18,
        });
    }
}

init();
